import { css } from '@emotion/react';

import normalize from './normalize';

const hideText = `
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
  padding: 0 !important;
  border: 0 !important;
  overflow: hidden !important;
  color: transparent !important;
  background: transparent !important;
  /* Some screen readers can interpret line breaks or wrapping as separate announcements or pauses, so make sure the
    text is all on one line. This helps to ensure the content is read as one continuous phrase. */
  white-space: nowrap !important;
  user-select: none;
  /* We can't use the usual 'clip' or 'clip-path' methods here, because it stops 'aria-live' elements from being read
     by VoiceOver in Safari. */
`;

export const globalCSS = css`
  *,
  *::before,
  *::after {
    box-sizing: border-box;
    -webkit-font-smoothing: antialiased;
    -webkit-text-size-adjust: 100%;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  }

  input,
  textarea {
    -webkit-touch-callout: default !important;
    -webkit-user-select: text !important;
  }

  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
    -webkit-transition: 'color 9999s ease-out, background-color 9999s ease-out';
    -webkit-transition-delay: 9999s;
  }

  ${normalize};

  @font-face {
    font-display: swap;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    src: local('Roboto'), local('Roboto-Regular'),
      url(https://fonts.gstatic.com/s/roboto/v18/KFOmCnqEu92Fr1Mu4mxK.woff2) format('woff2');
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC,
      U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
  }

  html {
    /* This ensures that the height is correct in Safari, the mobile app and in 'standalone' mode (installed via Safari
       onto the home screen of a mobile). */
    height: min(100vh, calc(100% + env(safe-area-inset-top) + env(safe-area-inset-bottom)));
  }

  body {
    height: 100%;
    padding-top: constant(safe-area-inset-top);
    padding-top: env(safe-area-inset-top);
    font-family: 'Roboto', sans-serif;
    font-size: 16px;
    -webkit-tap-highlight-color: transparent;
  }

  button {
    touch-action: manipulation;
    color: inherit;
  }

  svg text {
    font-size: inherit;
  }

  .hide-text {
    ${hideText};
    width: 1px !important;
    height: 1px !important;
    outline: none !important;
    margin: -1px !important;
  }

  .hide-text-show-focus {
    ${hideText};
    width: 100% !important;
    height: 100% !important;
    margin: 0 !important;
    pointer-events: none !important;
    top: 0;
    left: 0;
  }

  .flex {
    display: flex;
    width: 100%;
  }

  .alice-carousel {
    height: 100%;
  }

  .alice-carousel__dots {
    position: absolute;
    bottom: 14px;
    margin: 0;
    left: 50%;
    transform: translateX(-50%);
  }

  .alice-carousel__stage-item {
    overflow: hidden;
  }

  .alice-carousel__dots > li {
    vertical-align: middle;
  }
`;
